import { useContext } from 'react';
import {
  DataSources,
  Diligence,
  ImportedData,
  OtherData,
  OutcomeReasons,
  ReasonCodes,
  Tags,
  YourCustomer,
} from '../cards';
import { Col, Row } from '../common';
import { useEventTypeEvaluationsContext } from '../context';
import { hasReturnedReasonCodesData, hasDataSourcesData } from '../../utils/cardDataChecks';
import { shouldRenderCard } from '../../utils/shouldRenderCard';
import { FraudSignalCard } from '../../FraudSignalCard';
import { UserContext } from '~/dashboard/context';

export const BusinessUpdatedOverview = () => {
  const { evaluation } = useEventTypeEvaluationsContext();
  const { featureFlags } = useContext(UserContext);
  const hideEmptyCardsEnabled = !!featureFlags?.removeEmptyCards;

  return (
    <Row>
      <Col>
        <YourCustomer header="Business Updates" />
        <ImportedData />
      </Col>
      <Col>
        <OutcomeReasons />
        <Tags />
        <FraudSignalCard evaluationToken={evaluation.evaluation_token} />
        {shouldRenderCard(hasReturnedReasonCodesData(evaluation), hideEmptyCardsEnabled)
        && <ReasonCodes />}
        <Diligence />
        {shouldRenderCard(hasDataSourcesData(evaluation), hideEmptyCardsEnabled)
        && <DataSources />}
        <OtherData />
      </Col>
    </Row>
  );
};
